module.exports = __webpack_public_path__ + "319a7d33026a180eaf3cefaa5ec1ac6a.svg";